/// <amd-module name="Build/ArtifactsView/Components/ContainerImageDetails" />
import * as React from "react";
import { IBuildRestClient } from "Build/Client/RestClient/Build";
import * as BuildContracts from "Build/Client/Contracts/Build";
import { VssComponent, IVssComponentContext } from "VSS/Platform/Layout";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { Observer } from "VSSUI/Observer";
import { Spinner, SpinnerSize } from "VSSUI/Spinner";
import { ObservableValue } from "VSS/Core/Observable";
import { ImageDetails } from "Environments/Providers/External/Kubernetes/WebUI/ImageDetails/ImageDetails";
import { IImageDetails } from "Environments/Providers/External/Kubernetes/Contracts/Types";
import { onClickFPS } from "VSS/Platform/FPS";
import { NavConstants } from "Build/Common/Library/Constants";
import { IBuildLinkingService } from "Build/Client/Linking";
import { IVssHistoryService } from "VSS/Platform/History";
import { RouteParameters } from "Build/Client/Linking"
import { Surface, SurfaceBackground } from "VSSUI/Surface";
import { Page } from "VSSUI/Page";
import * as Build from "Build/Client/Contracts/Build";
import { ArtifactsHeaderBreadcrumbService } from "Build/ArtifactsView/Components/ArtifactsHeaderBreadcrumbService";

export interface ImageProps {
    imageUri: string;
    containerAlias: string;
    containerTag: string;
}

export class ContainerImageDetails extends VssComponent<ImageProps>  {

    constructor(props: ImageProps, context: IVssComponentContext) {
        super(props, context);
    }

    public render(): JSX.Element {
        return (
            <Observer data={this.data}>
                {
                    (observerProps: { data: IImageDetails | undefined }) => {
                        if (observerProps.data && observerProps.data.imageUri) {
                            return (
                                <Surface background={SurfaceBackground.neutral}>
                                    <Page className={"kubernetes-container flex flex-grow"}>
                                        {
                                            <ImageDetails imageDetails={observerProps.data} onBackButtonClick={this._navigateToArtifactsPage} />
                                        }
                                    </Page>
                                </Surface>
                            )
                        }
                        else {
                            return (
                                <div className="flex-column flex-grow">
                                    <Spinner size={SpinnerSize.medium} />
                                </div>
                            );
                        }
                    }
                }
            </Observer>
        );
    }

    public componentDidMount(): void {
        this._getImageDetails(this.props.imageUri).then(fetchedImageDetails => {
            this.data.value = fetchedImageDetails;
        });

        this._setBreadcrumbs();
    }

    private async _getBuildAsync(): Promise<Build.Build> {
        let buildId: string = this.historyService.getState()[RouteParameters.BuildId];
        let project: string = this.historyService.getState()[RouteParameters.Project];
        let buildClient = this.context.pageContext.getRestClient<IBuildRestClient>("IBuildRestClient");
        return buildClient.getBuild(project, parseInt(buildId));
    }

    private _setBreadcrumbs = (): void => {
        this._getBuildAsync().then((buildData: BuildContracts.Build) => {
            let pipelineName: string = buildData.definition.name;
            let pipelineUrl: string = this.linkingService.getDefinitionUrl(buildData.definition.id);
            let buildNumber: string = buildData.buildNumber;
            let buildId: number = buildData.id;
            let buildUrl: string = this.linkingService.getBuildUrl(buildId);
            let consumedArtifactsView: string = NavConstants.consumedArtifacts;
            let consumedArtifactsViewUrl: string = this.linkingService.getBuildUrl(buildId, NavConstants.artifacts, undefined, undefined, { [RouteParameters.Type]: consumedArtifactsView });
            let imageView: string = this.props.containerAlias + '/ ' + this.props.containerTag;
            let imageUrl: string = this.linkingService.getBuildUrl(buildId, NavConstants.artifacts, undefined, undefined, { [NavConstants.imageUri]: this.props.imageUri, [NavConstants.alias]: this.props.containerAlias, [NavConstants.tag]: this.props.containerTag });
            let breadcrumbService = this.context.pageContext.getService<ArtifactsHeaderBreadcrumbService>("artifacts-header-breadcrumb-service");
            breadcrumbService.setBreadcrumbs(pipelineName, pipelineUrl, buildNumber, buildUrl, consumedArtifactsView, consumedArtifactsViewUrl, imageView, imageUrl);
        });
    }

    private _navigateToArtifactsPage = (): void => {
        let pageContext = this.context.pageContext;
        let buildId: number = parseInt(this.historyService.getState()[RouteParameters.BuildId]);
        let consumedArtifactsView: string = NavConstants.consumedArtifacts;
        let consumedArtifactsViewUrl: string = this.linkingService.getBuildUrl(buildId, NavConstants.artifacts, undefined, undefined, { [RouteParameters.Type]: consumedArtifactsView });
        onClickFPS(pageContext, consumedArtifactsViewUrl, true);
    }

    public _getImageDetails(imageUri: string): Promise<IImageDetails | undefined> {
        const imageName = "https://" + imageUri;
        let additionalProperties = { imageName: imageName };
        let contributionService = this.context.pageContext.getService<IVssContributionService>("IVssContributionService");
        return contributionService.getDataAsync<IImageDetails>("ms.vss-environments-web.image-details-data-provider", additionalProperties, true);
    }

    private data: ObservableValue<IImageDetails | undefined> = new ObservableValue(undefined);
    private linkingService = this.context.pageContext.getService<IBuildLinkingService>("IBuildLinkingService");
    private historyService = this.context.pageContext.getService<IVssHistoryService>("IVssHistoryService");
}

VssComponent.register("run-summary-container-image-details", ContainerImageDetails);
